import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'

const propTypes    = {
  is_in_stock: PropTypes.bool
}
const defaultProps = {
  is_in_stock: false
}

/**
 * To give nice look on `is_in_stock`.
 * It maps `is_in_stock` to certain style and pass to `StatusBadge`.
 * @param {bool} is_in_stock Product is in stock status. available values
 * - true
 * - false
 */
const InStockBadge = ({ is_in_stock }) => {


  const color = is_in_stock ? 'success' : 'danger'

  const label = is_in_stock ? 'In Stock' : 'Out of Stock'

  return <StatusBadge color={ color } label={ label } />
}

InStockBadge.propTypes = propTypes

InStockBadge.defaultProps = defaultProps

export default InStockBadge